import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from '@folio/stripes-components';
import TextFieldComponent from '../TextFieldComponent';
import SelectFieldComponent from '../SelectFieldComponent';
import DateFieldComponent from '../DateFieldComponent';
import CheckboxFieldComponent from '../CheckboxFieldComponent';
import ToggleButton from '../ToggleButton';
import LocationFieldComponent from '../LocationFieldComponent';
import LanguageFieldComponent from '../LanguageFieldComponent';
import CustomTitleFieldComponent from '../CustomTitleFieldComponent';
import InstanceFieldComponent from '../InstanceFieldComponent';
import TextAreaFieldComponent from '../TextAreaFieldComponent';

export const fieldTypesComponents = {
  text: TextFieldComponent,
  textArea: TextAreaFieldComponent,
  select: SelectFieldComponent,
  date: DateFieldComponent,
  checkbox: CheckboxFieldComponent,
  toggleButton: ToggleButton,
  locationField: LocationFieldComponent,
  customTitle: CustomTitleFieldComponent,
  languageField: LanguageFieldComponent,
  instanceField: InstanceFieldComponent,
};

const propTypes = {
  fieldValues: PropTypes.object,
  fieldName: PropTypes.string,
  index: PropTypes.number,
  fields: PropTypes.object,
  controlledVocab: PropTypes.object,
  actionType: PropTypes.string,
};

function RenderFieldArrayComponent({
  fieldValues,
  fieldName,
  index,
  fields,
  controlledVocab,
  actionType,
}) {
  return (
    <Row>
      {fieldValues.fieldArray.map((field) => {
        const FieldComponent = fieldTypesComponents[field.type];
        const fieldSize = 12 / fieldValues.fieldArray.length;

        return (
          <Col xs={fieldSize} key={field.name}>
            <FieldComponent
              index={index}
              fieldValues={field}
              fieldName={`${fieldName}.${field.name}`}
              parentField={fieldValues}
              fields={fields}
              controlledVocab={controlledVocab}
              actionType={actionType}
            />
          </Col>
        );
      })}
    </Row>
  );
}

RenderFieldArrayComponent.propTypes = propTypes;

export default RenderFieldArrayComponent;
